import './custom-option.scss';

import React from 'react';
import { components } from 'react-select';

export function CustomOption(props) {
	const { address, selectProps } = props;
	const { useCheckbox } = selectProps || {};

	// when address prop is passed, format the address data to match secure site
	const addressData = props?.data?.value?.structured_formatting;
	const addressMainText = addressData?.main_text;
	const addressSecondaryText = addressData?.secondary_text;

	return (
		<div className='alma-checkbox'>
			<components.Option {...props}>
				{useCheckbox && (
					<>
						<input
							type='checkbox'
							checked={props.isSelected}
							onChange={() => null}
						/>{' '}
						<span className='alma-checkbox__icon'></span>
					</>
				)}

				<label>
					{address ? (
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<p style={{ fontWeight: 500, marginRight: 10 }}>
								{addressMainText}
							</p>
							<p
								style={{
									fontWeight: 300,
									color: 'grey',
									fontSize: '0.8rem',
								}}
							>
								{addressSecondaryText}
							</p>
						</div>
					) : (
						`${props.label}`
					)}
				</label>
			</components.Option>
		</div>
	);
}
